var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container box-page"},[_c('div',{staticClass:"site-wrapper-box"},[_c('div',{staticClass:"site-wrapper"},[_c('HeaderEbook'),_c('HeroEbook'),_c('EbookIntro'),_c('EbookChanters'),_c('EbookTestimonial'),_c('CtaThree',{attrs:{"id":"download"}}),_c('EbookMailchimp'),_c('FooterBottom'),_c('OffcanvasSearchBox')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }